/* ============================================================
   Product gallery — desktop click-to-swap, mobile snap-scroll
   syncing thumbs + dot indicator.
   ============================================================ */
(function () {
  'use strict';

  const galleries = document.querySelectorAll('[data-zc-gallery]');
  if (!galleries.length) return;

  galleries.forEach((gallery) => {
    const main = gallery.querySelector('[data-zc-gallery-main]');
    if (!main) return;
    const slides = Array.from(main.querySelectorAll('[data-zc-gallery-slide]'));
    const thumbs = Array.from(gallery.querySelectorAll('[data-zc-gallery-thumb]'));
    const dots = Array.from(gallery.querySelectorAll('[data-zc-gallery-dot]'));
    if (!slides.length) return;

    const mobileMq = window.matchMedia('(max-width: 1023px)');

    const setActive = (idx) => {
      slides.forEach((s, i) => s.classList.toggle('is-active', i === idx));
      thumbs.forEach((t, i) => {
        t.classList.toggle('is-active', i === idx);
        t.setAttribute('aria-selected', i === idx ? 'true' : 'false');
      });
      dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const idx = parseInt(thumb.dataset.mediaIndex, 10) || 0;
        setActive(idx);
        if (mobileMq.matches && slides[idx]) {
          slides[idx].scrollIntoView({ inline: 'start', block: 'nearest', behavior: 'smooth' });
        }
      });
    });

    // Mobile: sync dots/thumbs to scroll position.
    let scrollRaf = 0;
    const onScroll = () => {
      if (scrollRaf) return;
      scrollRaf = requestAnimationFrame(() => {
        scrollRaf = 0;
        const slideWidth = main.clientWidth;
        if (slideWidth === 0) return;
        const idx = Math.round(main.scrollLeft / slideWidth);
        const clamped = Math.max(0, Math.min(idx, slides.length - 1));
        thumbs.forEach((t, i) => {
          t.classList.toggle('is-active', i === clamped);
          t.setAttribute('aria-selected', i === clamped ? 'true' : 'false');
        });
        dots.forEach((d, i) => d.classList.toggle('is-active', i === clamped));
      });
    };
    main.addEventListener('scroll', onScroll, { passive: true });
  });
})();
